// Action types

export const AUTH_SET_USER = 'AUTH_SET_USER';
export const LOCALE_SET_LANG = 'LOCALE_SET_LANG';

export const PROGRAM_STORE_INFO = 'PROGRAM_STORE_INFO';

export const PROGRAM_SET_STEP = 'PROGRAM_SET_STEP';
export const PROGRAM_ASSIGN_TIERS = 'PROGRAM_ASSIGN_TIERS';

export const NAVIGATION_HAS_SIDEBAR = 'NAVIGATION_HAS_SIDEBAR';
export const NAVIGATION_TOGGLE_SIDEBAR = 'NAVIGATION_TOGGLE_SIDEBAR';
export const NAVIGATION_UPDATE_COMP_NAME = 'NAVIGATION_UPDATE_COMP_NAME';

export const NOTIFICATION_OPEN = 'NOTIFICATION_OPEN';
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE';

export const LOADING_SHOW = 'LOADING_SHOW';
export const LOADING_HIDE = 'LOADING_HIDE';

export const UPDATE_EDITOR_FIELD = 'UPDATE_EDITOR_FIELD';

export const CREATE_PRIZE_ITEM = 'CREATE_PRIZE_ITEM';
export const GET_PRIZE_ITEM = 'GET_PRIZE_ITEM';
export const GET_PRIZE_ITEMS = 'GET_PRIZE_ITEMS';
export const UPDATE_PRIZE_ITEM = 'UPDATE_PRIZE_ITEM';
export const DELETE_PRIZE_ITEM = 'DELETE_PRIZE_ITEM';
export const OPEN_PRIZE_EDITOR = 'OPEN_PRIZE_EDITOR';
export const CLOSE_PRIZE_EDITOR = 'CLOSE_PRIZE_EDITOR';

export const CREATE_REWARD_ITEM = 'CREATE_REWARD_ITEM';
export const GET_REWARD_ITEM = 'GET_REWARD_ITEM';
export const GET_REWARD_ITEMS = 'GET_REWARD_ITEMS';
export const UPDATE_REWARD_ITEM = 'UPDATE_REWARD_ITEM';
export const DELETE_REWARD_ITEM = 'DELETE_REWARD_ITEM';
export const OPEN_REWARD_EDITOR = 'OPEN_REWARD_EDITOR';
export const CLOSE_REWARD_EDITOR = 'CLOSE_REWARD_EDITOR';

export const GET_LOYALTY_CONFIG = 'GET_LOYALTY_CONFIG';
export const UPDATE_LOYALTY_CONFIG = 'UPDATE_LOYALTY_CONFIG';

export const GET_MERCHANT_LIST = 'GET_MERCHANT_LIST';
export const GET_DENOMINATION_LIST = 'GET_DENOMINATION_LIST';
export const GET_MERCHANT_INFO = 'GET_MERCHANT_INFO';
export const CLEAR_MERCHANT_INFO = 'CLEAR_MERCHANT_INFO'
